import React from "react";
import { useProviderInfoPageContext } from "../Context";

import { ProviderInfoContent } from "./ProviderInfoContent";
import { ProviderInfoHeader } from "./ProviderInfoHeader";
import { ProviderInfoMap } from "../Map/ProviderInfoMap";
import { FilterMetadataApiWithCountReturn, WaterProvider } from "../misc";

interface ProviderInfoProps {
    provider: WaterProvider;
    metadata: FilterMetadataApiWithCountReturn;
    className?: string;
    allowOnClick?: boolean;
    onFeatureClick?: (args: { code: string; feature: Record<string, unknown> }) => void;
    onRemove?: () => void;
    enabledHeightWatching?: boolean;
}
export const ProviderInfo: React.FC<ProviderInfoProps> = ({
    provider,
    metadata,
    className,
    allowOnClick = true,
    onRemove,
    onFeatureClick,
    enabledHeightWatching = false
}) => {
    return (
        <>
            <ProviderInfoHeader
                provider={provider}
                className={className ?? ""}
                onRemove={onRemove}
                enabledHeightWatching={enabledHeightWatching}
            />
            <ProviderInfoMap
                provider={provider}
                metadata={metadata}
                className={className ?? ""}
                allowOnClick={allowOnClick}
                onFeatureClick={onFeatureClick}
            />
            <ProviderInfoContent
                provider={provider}
                metadata={metadata}
                className={className ?? ""}
                enabledHeightWatching={enabledHeightWatching}
            />
        </>
    );
};

export const ProviderInfoWithContext = () => {
    const { provider, metadata } = useProviderInfoPageContext();
    return <ProviderInfo provider={provider} metadata={metadata} />;
};
